import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const PriorBariatricSurgery = (props: QuizStepProps) => {
  const hasError = !!props.errors?.PriorBariatricSurgery;
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("PriorBariatricSurgeryQuestion", value);
    props.handleStepData("PriorBariatricSurgery", "");
    if (value === "No") {
      setLastUpdate({ key: "PriorBariatricSurgeryQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <p className="pb-4 font-serif text-h3">
        Have you had prior bariatric (weight loss) surgery or any
        abdominal/pelvic surgeries? If yes, Please list all your prior bariatric
        (weight loss), abdominal, and pelvic surgeries. Please include date
        range and type of surgery.
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.PriorBariatricSurgeryQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div
        hidden={props.data.PriorBariatricSurgeryQuestion !== "Yes"}
        className="mt-4"
      >
        <TextArea
          label="Prior Bariatric Surgery"
          value={props.data.PriorBariatricSurgery as string}
          invalid={hasError}
          onChange={(value) =>
            props.handleStepData("PriorBariatricSurgery", value)
          }
        />
        {hasError && (
          <p className="mt-2 text-sm text-red">
            Please add information requested above.
          </p>
        )}
      </div>
      <div
        hidden={props.data.PriorBariatricSurgeryQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={() => props.next?.()}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
